import { composeCatalog, FlagKeyOf } from '@juno/shared/application/feature-flags';

/**
 * The composed runtime feature-flag catalog for the frontend SPA.
 *
 * SECURITY INVARIANT: this catalog composes ONLY `ui.*` fragments — never a
 * backend-only fragment (`behavior.*`, `routes.*`, `wiring.*`). The frontend
 * bundle must not ship backend flag metadata (keys, descriptions, defaults) to
 * SPA users, even though the `GET /feature-flags` endpoint already filters those
 * namespaces at runtime. Keeping backend fragments out of this composition root
 * enforces the invariant at the BUNDLE level, not just the response level.
 *
 * No `ui.*` fragment exists yet, so the catalog is currently empty. When a
 * dedicated `ui.*` fragment is added (a future ticket), it composes HERE — and
 * only here — so the SPA type surface stays UI-only by construction.
 */
export const FLAG_CATALOG = composeCatalog();

/** The closed union of all composed flag keys (currently empty). */
export type FlagKey = FlagKeyOf<typeof FLAG_CATALOG>;
